// About KUR page copy. Wording is from the original About page.
import adam from "../ASSETS/IMAGES/BW_Adam_Maciak.png";
import roshni from "../ASSETS/IMAGES/BW_Roshni-Dasgupta.png";
import jennifer from "../ASSETS/IMAGES/BW_JenniferHilton.png";
import patientIcon from "../ASSETS/ICONS/misisonPatient.svg";
import physicianIcon from "../ASSETS/ICONS/misisonPhysician.svg";
import employeeIcon from "../ASSETS/ICONS/misisonEmp.svg";
import sponsorIcon from "../ASSETS/ICONS/misisonSponsor.svg";

export const aboutHero = {
  lead: "KUR Research is a leader in facilitating clinical research in urgent care centers and private practices.",
  pillars: ["Multi-Speciality", "Experienced Investigators & Staff", "Population Diversity"],
  actions: [
    { label: "Partner with KUR", href: "/physicians" },
    { label: "Talk to KUR", href: "/contact" },
  ],
};

export const story = [
  "KUR Research is an integrated clinical research site network with over a decade of experience and a proven track record of success from hundreds of clinical trials. KUR Research is part of the KUR International Group, a global healthcare conglomerate dedicated to furthering science, research and patient well-being.",
  "Within KUR Research, there are eighteen clinical research locations throughout six states. KUR provides sponsors with the opportunity to conduct a wide variety of clinical trials with a diverse population that reflects the diversity of KUR’s team members and investigators as well. As the urgent care industry continues to grow and align with complementary healthcare, so do we. We operate with pain management facilities, primary care groups, cardiologists, dermatologists, and more.",
];

export const partnership =
  "By partnering with local community based, established urgent cares and physician offices, we are able to develop clinical research sites within their practices and provide all the necessary resources to successfully run clinical research such as providing clinical trials development, insuring quality and training, regulatory oversight, contract and budget negotiations, study marketing, patient scheduling, data management, daily coordination and onsite management, and much more. Our goal is to provide physicians with as much administrative and clinical support as possible so physicians can concentrate on patient care.";

// TODO(KUR): "14 years / over 100 clinical trials" conflicts with the
// 11 years / 823+ studies used elsewhere; confirm before changing.
export const advantage = [
  "KUR™ works towards achieving clear competitive advantages and increasing value in urgent care centers and private practice by facilitating clinical research through complete clinical trial management, creating true enterprise value. We strive to not only increase value by creating a significant secondary revenue stream, but through the ability to offer treatments and medications to patients that they would never have the opportunity to receive. Our physicians are working with the latest treatments while having a direct impact on the future of medicine.",
  "We are seasoned experts in the field of clinical trials, specifically in the urgent care and private practice environment. What separates us from everyone else is our experience and commitment to staying current with the ever-changing clinical research environment and recognizing the impact of such research with physicians. With over 14 years’ experience managing clinical research sites, we have worked on over 100 clinical trials in various therapeutic areas from inception to completion.",
];

export const mission = [
  {
    audience: "Patients",
    icon: patientIcon,
    text: "To improve our patients' lives with the most advanced medical treatments, superior healthcare oversight, and education about their medical conditions.",
  },
  {
    audience: "Physicians",
    icon: physicianIcon,
    text: "To provide our physicians with the highest quality clinical support and an opportunity to directly aid in the development of the latest medical treatments and technologies.",
  },
  {
    audience: "Employees",
    icon: employeeIcon,
    text: "To give our employees unlimited growth potential and a company they can be proud of.",
  },
  {
    audience: "Sponsors",
    icon: sponsorIcon,
    text: "To deliver our sponsors a seamless experience in the advancement of clinical research by consistently delivering quality data, fast enrollment, and reliability.",
  },
];

export const leaders = [
  { name: "Adam Maciak", role: "Chief Executive Officer and Founder", company: "KUR International", image: adam },
  { name: "Roshni Dasgupta", role: "Chief Financial Officer", company: "KUR International", image: roshni },
  { name: "Jennifer Hilton", role: "Senior Director of Operations", company: "KUR International", image: jennifer },
];
